const apiUrl = '';

export const environment = {
  production: true,
  apiUrl: '',
  hawksimUrl: '/hawksim/', // same-origin: served at /hawksim/ by the frontend Caddy
  devMode: false,
  userIdle: 600,
  userTimeout: 30,
};

export const GIS_IMAGE_URL = `${apiUrl}/gis-image/`;
